import routes from '@routes/config';
// console.log(routes);
export default [{
    path: routes.company.index,
    name: routes.company.index,
    component: () => import(/* webpackChunkName: "Company" */  '@components/Company/Index')
}]
